export enum Categories {
  PersonalNav = 'personal nav',
  GeneralNav = 'general nav',
  MobileNav = 'mobile navigation',
  Logo = 'logo',
  LanguageSelection = 'language selection',
  GovBanner = 'gov banner',
  Messages = 'message center'
}
